import { useCallback } from 'react';

const useUpdateOverflowCarouselState = ({
  setShowPreviousButton,
  setShowNextButton,
  setShouldShowOverflow,
  isMobileBrowser,
}: {
  setShowPreviousButton: (show: boolean) => void;
  setShowNextButton: (show: boolean) => void;
  setShouldShowOverflow: (show: boolean) => void;
  isMobileBrowser: boolean;
}) => {
  return useCallback<(carouselRefCurrent: HTMLDivElement | null, contentRefCurrent: HTMLDivElement | null) => void>(
    (carouselRefCurrent, contentRefCurrent) => {
      if (!contentRefCurrent || !carouselRefCurrent) {
        return;
      }
      if (carouselRefCurrent.offsetWidth < contentRefCurrent.offsetWidth) {
        setShouldShowOverflow(true);
      } else {
        setShouldShowOverflow(false);
      }

      // if the user is on a mobile browser, they should be able to swipe to see hidden content, so don't show the buttons
      if (isMobileBrowser) {
        return;
      }

      if (Math.abs(carouselRefCurrent.scrollLeft) > 0) {
        setShowPreviousButton(true);
      } else {
        setShowPreviousButton(false);
      }

      if (Math.abs(carouselRefCurrent.scrollLeft) + carouselRefCurrent.offsetWidth >= contentRefCurrent.offsetWidth) {
        setShowNextButton(false);
      } else {
        setShowNextButton(true);
      }
    },
    [setShowNextButton, setShowPreviousButton, isMobileBrowser, setShouldShowOverflow]
  );
};

export default useUpdateOverflowCarouselState;
